import { registerBlockType, getBlockType } from '@wordpress/blocks';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

if(!getBlockType('preciseinvestigation/hero-slider-slide')) {
  registerBlockType('preciseinvestigation/hero-slider-slide', {
    title: 'Slide',
    icon: 'pets',
    category: 'preciseinvestigation',
    parent: [ 'preciseinvestigation/hero-slider' ],
    edit: (props) => editComponent(props),
    save: (props) => saveComponent(props),
  });
}

function editComponent() {
  const blockProps = useBlockProps();
  const TEMPLATE = [
    [ 'core/cover', {} ]
  ];
  return (
    <div {...blockProps}>
      <InnerBlocks template={TEMPLATE} />
    </div>
  );
}

function saveComponent() {
  const blockProps = useBlockProps.save();
  return (
    <div {...blockProps} className="splide__slide">
      <InnerBlocks.Content />
    </div>
  );
}
